import Cookies from 'cookies-js';

export const LAST_LOGIN_METHOD_COOKIE = 'ut_last_login_method';

export const LastLoginMethods = {
    PWD: 'pwd',
    MAGIC_LINK: 'magic_link',
    APPLE: 'apple',
    FACEBOOK: 'facebook',
    TA: 'ta',
};

const INDICATABLE_METHODS = new Set(Object.values(LastLoginMethods));

export const getLastUsedLoginMethod = () => {
    if (typeof document === 'undefined') {
        return null;
    }
    const method = Cookies.get(LAST_LOGIN_METHOD_COOKIE);
    // `google` is a valid backend value but there is no Google tile on this sign-in
    // form, so it — like any unrecognised value — has nothing to indicate.
    return INDICATABLE_METHODS.has(method) ? method : null;
};

// Which method the sign-in form should badge. The gate has to be checked client-side: pre-auth
// traffic evaluates server-side gates as anonymous, so the server cannot resolve this.
export const resolveBadgeMethod = (checkGate, featureGates) => {
    if (!checkGate || !featureGates) {
        return null;
    }
    return checkGate(featureGates.LOGIN_NUDGE) ? getLastUsedLoginMethod() : null;
};
